// extracted by mini-css-extract-plugin
module.exports = {"box":"_8gRVudh32-LbeSIf1CRV+Q==","visible":"_5C5srAY0nJMNeE-Bt9QFSw==","fadein":"fil2OQU6+S4JoqjTaS28zw==","loading":"lKOS+Xs7oOkzw1e6xbSQFw=="};